import React, {useEffect, useState} from 'react';
import {Link, navigate} from 'gatsby';
import {faSpinner} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Table} from 'react-bootstrap';

import {
  getDateAndTime,
  // getToolNameHistory,
  // setToolNameHistory
} from '../../../helpers';
import {freeToolsErrors, toolsList, toolsListName} from '../../../helpers/constants';
import {toolHistoryRequest} from '../../../requests';

import Select from '../../../components/select';
import NothingToShow from '../../nothingToShow';
import Pagination from '../../pagination';

import {arrowRight} from '../../../images/svgIcons';

import './styles.scss';

// const getLocalStorage = (): {label: string; value: string} => {
//   const tool = getToolNameHistory();
//   if (tool) {
//     return JSON.parse(tool);
//   }
//   setToolNameHistory(JSON.stringify({label: 'All', value: ''}));
//   return {label: 'All', value: ''};
// };

const ToolsHostoryWrapper = (props: any) => {
  // const {user} = useContext(UserContext);
  // const [selectedTool, setSelectedTool] = useState(getLocalStorage);
  const [selectedTool, setSelectedTool] = useState({value: '', label: 'All'});
  const [result, setResult] = useState([]);
  const [loading, setLoading] = useState(false);
  const [_, setError] = useState('');
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);

  // useEffect(() => {
  //   if (user && Object.keys(user) && Object.keys(user).length && !user.id) navigate('/#login');
  // }, [user]);

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;
    if (props.filter) {
      timeoutId = setTimeout(() => {
        const filteredTool = toolsList.find(item => item.value === props.filter);
        filteredTool && setSelectedTool(filteredTool);
      }, 50);
    }
    return () => clearTimeout(timeoutId);
  }, [props]);

  useEffect(() => {
    // const selectedToolValue = getToolNameHistory();

    // if (!selectedToolValue) {
    //   return;
    // }

    const fetchID = async () => {
      setLoading(true);
      setError('');
      try {
        const res = await toolHistoryRequest(selectedTool.value, page);
        setResult(res?.result);
        setTotal(res?.total);
        setLoading(false);
      } catch (e) {
        console.log(e);
        setLoading(false);
        setError('Something went wrong. Please try again.');
      }
    };
    fetchID();
  }, [selectedTool, page]);

  return (
    <>
      {loading ? (
        <div className="mx-auto mb-5">
          <FontAwesomeIcon icon={faSpinner} className="button-loading" />
        </div>
      ) : (!result || result.length < 1) && !selectedTool.value ? (
        <div className="mb-5 w-100">
          <Link to="/tools">← Back to tools</Link>
          <div className=" d-flex justify-content-center">
            <NothingToShow />
          </div>
        </div>
      ) : (
        <>
          <div className="history-select d-flex mb-2 w-100">
            <Link className="n-wrap" to="/tools">
              ← Back to tools
            </Link>
            <Select
              options={toolsList}
              onChange={(val: any) => {
                // setToolNameHistory(val);
                setSelectedTool(val);
                setPage(1);
              }}
              value={selectedTool}
              className="ml-auto"
            />
          </div>
          {!result || result.length < 1 ? (
            <div className="mb-5 w-100">
              <div className="d-flex justify-content-center">
                <NothingToShow />
              </div>
            </div>
          ) : (
            <div className="tools-history-card col-12 p-2 mb-4">
              <Table className="table mb-0 border-0 w-100" responsive hover>
                <thead>
                  <tr>
                    <th>Source</th>
                    <th className="width_190">Tool name</th>
                    <th className="width_230">Scan date</th>
                    <th className="width_230">Status</th>
                    <th className="width_50"></th>
                  </tr>
                </thead>
                <tbody>
                  {result.map(
                    (item: {
                      toolName: string;
                      createdAt: string;
                      source: string;
                      result: any;
                      _id: string;
                      status: string;
                    }) => (
                      <tr
                        key={item._id}
                        className={`bordered ${freeToolsErrors.includes(item.result[0]) ? 'disabled' : ''}`}
                        onClick={() => item.status !== 'PENDING' && navigate(`/tools/history/${item._id}/`)}
                      >
                        <td className="source" title={item.source}>
                          {item.source}
                        </td>
                        <td className="width_190">{toolsListName[item.toolName] || ''}</td>
                        <td className="width_230">{getDateAndTime(item.createdAt)}</td>
                        <td className={`width_230 ${freeToolsErrors.includes(item.result[0]) ? '' : item.status}`}>
                          {freeToolsErrors.includes(item.result[0]) ? item.result[0] : item.status}
                        </td>
                        <td className={'width_50 text-right pr-4'}>
                          {freeToolsErrors.includes(item.result[0]) || item.status === 'PENDING' ? '' : arrowRight}
                        </td>
                      </tr>
                    ),
                  )}
                </tbody>
              </Table>
            </div>
          )}
          {total > 10 && (
            <div className="d-flex justify-content-center w-100 mt-3">
              <Pagination activePage={page} totalCount={total} onChange={setPage} itemsPerPage={10} />
            </div>
          )}
        </>
      )}
    </>
  );
};

export default ToolsHostoryWrapper;
